import { CountryFlagByAlpha2 } from '@pay-com/icons'
import { twMerge } from 'tailwind-merge'

export const CountryFlag = ({
  alpha2,
  className,
  currencyAlpha3,
  variant = 'softCorner'
}: Parameters<typeof CountryFlagByAlpha2>[0]) => (
  <CountryFlagByAlpha2
    alpha2={alpha2}
    variant={variant}
    currencyAlpha3={currencyAlpha3}
    className={twMerge('max-h-[0.9375rem] w-[1.3125rem]', className)}
  />
)
